import { useRef } from 'react'
import { useSetState } from 'ahooks'
import { Button, DatePicker, Form, message, Upload } from 'antd'
import {
  SActionBtn,
  SBack,
  SDrawerOrModal,
  SFuncModal,
  SFuncModalFormRef,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons'

import { httpOrgList } from '@/services/homeService.ts'
import {
  getPriceLimitImportFeesPage,
  getProductManagementPage,
  priceLimitImportFeesBatchDelete,
  priceLimitImportFeesBatchUpdateDate,
  priceLimitImportFeesImport,
} from '@/services/product.ts'
import { config } from './config.tsx'
import AddOrEditConfigure from './addOrEdit/index.tsx'
import { apiData2Table } from '@/utils/data.ts'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { get } from 'lodash-es'
import { fileDownload } from '@/utils/download.ts'
import UrlConfig from '@/api/UrlConfigs.ts'
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import dayjs from 'dayjs'

const LimitImportConfigList = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [search] = useSearchParams()
  const name = search.get('name')
  const type = search.get('type')
  const listRef = useRef()
  const editRef = useRef<SFuncModalFormRef>({ onFinish: undefined })
  const [form] = Form.useForm()

  const [state, setState] = useSetState<any>({
    exportLoading: false,
    loading: false,
    visible: false,
    record: {},
    importLoading: false,
    dateVisible: false,
  })

  const getOptions = async () => {
    const companyList = await httpOrgList()
    return Promise.resolve({ companyList: [{ id: '0', name: '通用' }, ...companyList] })
  }

  const fetchList = ({ current, pageSize, query }) => {
    if (!id) return
    return new Promise((resolve, reject) => {
      getPriceLimitImportFeesPage({
        params: { pageId: current, pageSize },
        data: { ...query, priceItemId: id, searchFlag: true },
      })
        .then(res => {
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onAddOrEdit = (record = {}) => {
    setState({ visible: true, record: { ...record } })
  }

  const delConfirm = apiFun => {
    SMessage.confirm({
      onOk: () => {
        return apiFun().then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }

  const onDel = (id: string) => {
    delConfirm(() => priceLimitImportFeesBatchDelete([id]))
  }

  const onBatchDel = ({ selectedRowKeys }: { selectedRowKeys: string[] }) => {
    delConfirm(() => priceLimitImportFeesBatchDelete(selectedRowKeys))
  }

  const onSubmit = () => {
    editRef.current.onFinish?.()
  }

  const goBack = () => {
    navigate(`/config/priceTagManage?type=${type}`, { state: { saveCache: true } })
  }

  const onCancel = () => {
    setState({ visible: false, record: {} })
  }

  const onImport = (upload: any) => {
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    data.append('priceItemId', id)
    setState({ importLoading: true })
    return priceLimitImportFeesImport(data)
      .then((res: any) => {
        const msg = get(res, 'data') || ''
        listRef.current && listRef.current.reload()
        onSuccess && onSuccess()
        message.success(msg || '导入成功')
        setState({ importLoading: false })
      })
      .catch(onError)
      .finally(() => setState({ importLoading: false }))
  }

  const onExport = () => {
    setState({ exportLoading: true })
    fileDownload(UrlConfig.PlusProductWeb.PriceLimitImportFeesDownload)
      .then(() => setState({ exportLoading: false }))
      .catch(() => setState({ exportLoading: false }))
  }
  const onBatchUpDateStart = ({ selectedRowKeys }: { selectedRowKeys: string[] }) => {
    postData({
      ids: selectedRowKeys,
      type: 'startDate',
      label: '开始日期',
      required: true,
    })
  }
  const onBatchUpDateEnd = ({ selectedRowKeys }: { selectedRowKeys: string[] }) => {
    postData({
      ids: selectedRowKeys,
      type: 'endDate',
      label: '结束日期',
      required: false,
    })
  }
  const postData = data => {
    const dialog = SFuncModal({
      title: '修改日期',
      content: (
        <Form form={form}>
          <Form.Item
            label={data.label}
            name="date"
            required={data.required}
            rules={[{ required: data.required, message: data.label + '不能为空' }]}
          >
            <DatePicker style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      ),
      onOk: () => {
        form.validateFields().then((values: Record<string, string>) => {
          values.date = values.date && dayjs(values.date).format('YYYY-MM-DD')
            priceLimitImportFeesBatchUpdateDate({
              data: {
                ...values,
                ids: data.ids,
                type: data.type,
              },
            })
              .then(res => {
                message.success('操作成功')
                form.resetFields()
                listRef.current?.reload()
                dialog.destroy()
              })
              .catch(() => {
                form.resetFields()
                dialog.destroy()
              })
       
        })
      },
      onCancel: () => {
        form.resetFields()
        dialog.destroy()
      },
    })
  }
  const extensions = {
    request: { fetchList, getOptions },
    events: { onBatchDel, onBatchUpDateStart, onBatchUpDateEnd },
    customRender: {
      jsonRender(v: any) {
        const { shops: list } = v && JSON.parse(v)
        return list?.map(item => item.name)?.join(', ')
      },
      actionRender(_: null, record: Record<string, any>) {
        return (
          <STableActions>
            <SActionBtn onClick={() => onAddOrEdit(record)}>编辑</SActionBtn>
            <SActionBtn danger onClick={() => onDel(record.id)}>
              删除
            </SActionBtn>
          </STableActions>
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button loading={state.importLoading} type={'primary'} icon={<UploadOutlined />}>
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button icon={<DownloadOutlined />} onClick={onExport} loading={state.exportLoading}>
            下载导入模板
          </Button>
        )
      },
      nameRender() {
        return name
      },
      sortRender(v, r, i) {
        return i + 1
      },
      projectListRender: ({ name, form }) => {
        return (
          <DebounceSearchSelect
            allowClear
            label={'产品'}
            fetchOptions={getProductManagementPage}
            onChange={v => form.setFieldsValue({ [name]: v })}
            fieldNames={{ label: 'prodName' }}
          />
        )
      },
    },
  }

  return (
    <SBack title={`${name}导入费用`} level={2} goPath={goBack}>
      <div>
        {/*<div style={{ padding: '20px 20px 0 20px', background: '#fff' }}></div>*/}
        <SLowcodeList ref={listRef} searchMode={'group'} config={config} {...extensions} />
        <SDrawerOrModal
          mode={'modal'}
          onCancel={onCancel}
          onOk={onSubmit}
          width={710}
          loading={state.loading}
          open={state.visible}
          title={(state.record.id ? '编辑' : '新增') + '配置'}
        >
          {state.visible && (
            <AddOrEditConfigure
              fn={listRef.current?.reload}
              onClose={onCancel}
              editRef={editRef}
              mode={'modal'}
              setLoading={(loading: boolean) => setState({ loading })}
              priceItemId={id}
              companyList={state.companyList}
              record={state.record}
            />
          )}
        </SDrawerOrModal>
      </div>
    </SBack>
  )
}

export default LimitImportConfigList
